/**
 * Brand Constants
 */

export const BRAND_NAME = "CherryClipz";
export const BRAND_LOGO_ALT = "CherryClipz Logo";
